var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "el-card-main", style: _vm.mainStyle }, [
    _c(
      "div",
      {
        staticStyle: { position: "relative" },
        attrs: { id: "main-attr" },
        on: { mousedown: _vm.mouseDown },
      },
      [
        _vm.attrShow("textAlign")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "100px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "mini" },
                    on: { change: _vm.styleChange },
                    model: {
                      value: _vm.styleInfo.textAlign,
                      callback: function ($$v) {
                        _vm.$set(_vm.styleInfo, "textAlign", $$v)
                      },
                      expression: "styleInfo.textAlign",
                    },
                  },
                  _vm._l(_vm.textAlignOptions, function (item) {
                    return _c(
                      "el-radio-button",
                      { key: item.label, attrs: { label: item.label } },
                      [
                        _c("el-tooltip", { attrs: { content: item.tooltip } }, [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _c("i", { class: item.icon }),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("borderStyle")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "80px",
                  "margin-top": "2px",
                  "margin-left": "2px",
                  float: "left",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: "边框风格" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: { change: _vm.styleChange },
                        model: {
                          value: _vm.styleInfo.borderStyle,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "borderStyle", $$v)
                          },
                          expression: "styleInfo.borderStyle",
                        },
                      },
                      _vm._l(_vm.lineStyle, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          },
                          [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _c("i", { class: item.icon }),
                            ]),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "right",
                                  color: "#8492a6",
                                  "font-size": "12px",
                                },
                              },
                              [_vm._v(_vm._s(item.label))]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("borderWidth")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "60px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: "边框宽度" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", placeholder: "" },
                        on: { change: _vm.styleChange },
                        model: {
                          value: _vm.styleInfo.borderWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "borderWidth", $$v)
                          },
                          expression: "styleInfo.borderWidth",
                        },
                      },
                      _vm._l(_vm.lineFont, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("fontSize")
          ? _c("el-tooltip", { attrs: { content: _vm.$t("panel.fontSize") } }, [
              _c("i", {
                staticClass: "iconfont icon-font_size",
                staticStyle: {
                  float: "left",
                  "margin-top": "3px",
                  "margin-left": "2px",
                },
              }),
            ])
          : _vm._e(),
        _vm.attrShow("fontSize")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "number",
                    size: "mini",
                    min: _vm.miniFontSize,
                    max: _vm.maxFontSize,
                  },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.initFontSize,
                    callback: function ($$v) {
                      _vm.initFontSize = $$v
                    },
                    expression: "initFontSize",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("activeFontSize")
          ? _c(
              "el-tooltip",
              { attrs: { content: _vm.$t("panel.active_font_size") } },
              [
                _c("i", {
                  staticClass: "iconfont icon-font",
                  staticStyle: {
                    float: "left",
                    "margin-top": "3px",
                    "margin-left": "2px",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm.attrShow("activeFontSize")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "number",
                    size: "mini",
                    min: _vm.miniFontSize,
                    max: _vm.maxFontSize,
                  },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.initActiveFontSize,
                    callback: function ($$v) {
                      _vm.initActiveFontSize = $$v
                    },
                    expression: "initActiveFontSize",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("fontWeight")
          ? _c(
              "el-tooltip",
              { attrs: { content: _vm.$t("panel.fontWeight") } },
              [
                _c("i", {
                  staticClass: "icon iconfont icon-font-weight-bold",
                  staticStyle: {
                    float: "left",
                    "margin-top": "3px",
                    "margin-left": "2px",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm.attrShow("fontWeight")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "number",
                    size: "mini",
                    min: "100",
                    step: "100",
                    max: "900",
                  },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.styleInfo.fontWeight,
                    callback: function ($$v) {
                      _vm.$set(_vm.styleInfo, "fontWeight", $$v)
                    },
                    expression: "styleInfo.fontWeight",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("letterSpacing")
          ? _c(
              "el-tooltip",
              { attrs: { content: _vm.$t("panel.letterSpacing") } },
              [
                _c("i", {
                  staticClass: "icon iconfont icon-letter_spacing",
                  staticStyle: {
                    float: "left",
                    "margin-top": "3px",
                    "margin-left": "2px",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm.attrShow("letterSpacing")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: { type: "number", size: "mini", min: "0", max: "99" },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.styleInfo.letterSpacing,
                    callback: function ($$v) {
                      _vm.$set(_vm.styleInfo, "letterSpacing", $$v)
                    },
                    expression: "styleInfo.letterSpacing",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("margin")
          ? _c("el-tooltip", { attrs: { content: _vm.$t("panel.margin") } }, [
              _c("i", {
                staticClass: "icon iconfont icon-margin",
                staticStyle: {
                  float: "left",
                  "margin-top": "3px",
                  "margin-left": "2px",
                },
              }),
            ])
          : _vm._e(),
        _vm.attrShow("margin")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: { type: "number", size: "mini", min: "0", max: "99" },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.styleInfo.margin,
                    callback: function ($$v) {
                      _vm.$set(_vm.styleInfo, "margin", $$v)
                    },
                    expression: "styleInfo.margin",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("opacity")
          ? _c("el-tooltip", { attrs: { content: _vm.$t("panel.opacity") } }, [
              _c("i", {
                staticClass: "icon iconfont icon-touming",
                staticStyle: {
                  float: "left",
                  "margin-top": "3px",
                  "margin-left": "2px",
                },
              }),
            ])
          : _vm._e(),
        _vm.attrShow("opacity")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "number",
                    size: "mini",
                    min: "0",
                    max: "100",
                    step: "10",
                  },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.innerOpacity,
                    callback: function ($$v) {
                      _vm.innerOpacity = $$v
                    },
                    expression: "innerOpacity",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("borderRadius")
          ? _c(
              "el-tooltip",
              { attrs: { content: _vm.$t("panel.borderRadius") } },
              [
                _c("i", {
                  staticClass: "icon iconfont icon-fangxing-",
                  staticStyle: {
                    float: "left",
                    "margin-top": "3px",
                    "margin-left": "2px",
                  },
                }),
              ]
            )
          : _vm._e(),
        _vm.attrShow("borderRadius")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "70px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c("el-input", {
                  attrs: {
                    type: "number",
                    size: "mini",
                    min: "0",
                    max: "100",
                    step: "1",
                  },
                  on: { change: _vm.styleChange },
                  model: {
                    value: _vm.styleInfo.borderRadius,
                    callback: function ($$v) {
                      _vm.$set(_vm.styleInfo, "borderRadius", $$v)
                    },
                    expression: "styleInfo.borderRadius",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("color")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "16px", height: "18px" } },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: _vm.$t("panel.color") } },
                      [
                        _c("i", {
                          staticClass: "icon iconfont icon-zimua",
                          on: { click: _vm.goColor },
                        }),
                      ]
                    ),
                    _c("div", { style: _vm.letterDivColor }),
                    _c("el-color-picker", {
                      ref: "colorPicker",
                      staticStyle: { "margin-top": "7px", height: "0px" },
                      attrs: { size: "mini", predefine: _vm.predefineColors },
                      on: { change: _vm.styleChange },
                      model: {
                        value: _vm.styleInfo.color,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "color", $$v)
                        },
                        expression: "styleInfo.color",
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm.attrShow("borderColor")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "16px", height: "18px" } },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: _vm.$t("panel.border_color") } },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-huabi",
                          on: { click: _vm.goBoardColor },
                        }),
                      ]
                    ),
                    _c("div", { style: _vm.boardDivColor }),
                    _c("el-color-picker", {
                      ref: "boardColorPicker",
                      staticStyle: { "margin-top": "7px", height: "0px" },
                      attrs: { size: "mini", predefine: _vm.predefineColors },
                      on: { change: _vm.styleChange },
                      model: {
                        value: _vm.styleInfo.borderColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "borderColor", $$v)
                        },
                        expression: "styleInfo.borderColor",
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm.attrShow("backgroundColor")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "16px", height: "18px" } },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: _vm.$t("panel.background_color") } },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-beijingse1",
                          on: { click: _vm.goBackgroundColor },
                        }),
                      ]
                    ),
                    _c("div", { style: _vm.backgroundDivColor }),
                    _c("el-color-picker", {
                      ref: "backgroundColorPicker",
                      staticStyle: { "margin-top": "7px", height: "0px" },
                      attrs: { predefine: _vm.predefineColors, size: "mini" },
                      on: { change: _vm.styleChange },
                      model: {
                        value: _vm.styleInfo.backgroundColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "backgroundColor", $$v)
                        },
                        expression: "styleInfo.backgroundColor",
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm.attrShow("videoLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.video_info") } },
                  [
                    _c("VideoLinks", {
                      attrs: { "link-info": _vm.curComponent.videoLinks },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("streamMediaLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.stream_media_info") } },
                  [
                    _c("StreamMediaLinks", {
                      attrs: { "link-info": _vm.curComponent.streamMediaLinks },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("frameLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "2px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.web_addr") } },
                  [
                    _c("FrameLinks", {
                      attrs: { "link-info": _vm.curComponent.frameLinks },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("date-format")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.data_format") } },
                  [
                    _c("date-format", {
                      attrs: {
                        "canvas-id": _vm.canvasId,
                        "format-info": _vm.curComponent.formatInfo,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("deTabStyle")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.tab_inner_style") } },
                  [_c("tab-style", { attrs: { "style-info": _vm.styleInfo } })],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("titlePosition")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.title_position") } },
                  [
                    _c("title-position", {
                      attrs: {
                        "element-type": _vm.elementType,
                        "show-vertical": _vm.showVertical,
                        "style-info": _vm.styleInfo,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrTabShow("videoLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.video_info") } },
                  [
                    _c("VideoLinks", {
                      attrs: {
                        "attr-position": "tab",
                        "link-info": _vm.curActiveTabInner.videoLinks,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrTabShow("streamMediaLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.stream_media_info") } },
                  [
                    _c("StreamMediaLinks", {
                      attrs: {
                        "attr-position": "tab",
                        "link-info": _vm.curActiveTabInner.streamMediaLinks,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrTabShow("frameLinks")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "20px",
                  float: "left",
                  "margin-top": "2px",
                  "margin-left": "10px",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.web_addr") } },
                  [
                    _c("FrameLinks", {
                      attrs: {
                        "attr-position": "tab",
                        "link-info": _vm.curActiveTabInner.frameLinks,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.attrShow("adaptation")
          ? _c(
              "div",
              {
                staticStyle: {
                  width: "100px",
                  "margin-top": "2px",
                  "margin-right": "2px",
                  float: "left",
                },
              },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: _vm.$t("panel.pic_size") } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: { change: _vm.styleChange },
                        model: {
                          value: _vm.styleInfo.adaptation,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "adaptation", $$v)
                          },
                          expression: "styleInfo.adaptation",
                        },
                      },
                      _vm._l(_vm.pictureAdaptation, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }